// Paleta y tipografías del home (fondo Azul Noche, Poppins), compartidas por las
// pantallas de la vidriera para que se sientan parte del mismo sitio.
// Los valores salen del Manual de Marca (src/brand.js).
import { BRAND, FONT_FAMILY, FONTS_HREF as BRAND_FONTS_HREF } from '../../brand';

export const COLORS = {
    background: BRAND.night,
    surface: BRAND.night2,
    card: BRAND.night3,
    border: 'rgba(255,255,255,0.1)',
    borderHover: 'rgba(255,255,255,0.25)',
    text: 'white',
    muted: '#AAB6C6',
    subtle: '#8B99AD',
    accent: BRAND.blue,
    call: BRAND.green,
    callHover: BRAND.greenDark,
    open: BRAND.green,
    closed: BRAND.error,
};

export const FONT_TITLE = FONT_FAMILY;
export const FONT_BODY = FONT_FAMILY;

export const FONTS_HREF = BRAND_FONTS_HREF;

export const skeletonSx = { bgcolor: 'rgba(255,255,255,0.08)' };

export const callButtonSx = {
    backgroundColor: COLORS.call,
    color: COLORS.background,
    fontWeight: 700,
    fontFamily: FONT_TITLE,
    fontSize: '1rem',
    px: 4,
    py: 1.5,
    borderRadius: '999px',
    '&:hover': {
        backgroundColor: COLORS.callHover,
        boxShadow: '0 8px 24px rgba(41,210,171,0.35)',
    },
};

export const secondaryButtonSx = {
    color: 'white',
    borderColor: 'rgba(255,255,255,0.3)',
    fontFamily: FONT_TITLE,
    fontWeight: 600,
    borderRadius: '999px',
    '&:hover': {
        borderColor: 'white',
        backgroundColor: 'rgba(255,255,255,0.06)',
    },
};
